import { FetchResult, useMutation } from '@apollo/client'
import { enqueueSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { CREATE_GOOGLE_AD_MANAGER_CONNECTION } from './api/mutation'
import { Data } from './api/types'
import { UseCreateConnection } from './types'

export const useCreateConnection = (): UseCreateConnection => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.connectionStatus',
  })

  const [mutate, { loading }] = useMutation(CREATE_GOOGLE_AD_MANAGER_CONNECTION, {
    onCompleted: ({ createGamConnectionOrder: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        enqueueSnackbar(t('notification.error'), { variant: 'error' })
      }
    },
    refetchQueries: ['getGoogleAdManagerConnection'],
  })

  const create = (): Promise<FetchResult<Data>> =>
    mutate({
      variables: {
        input: { workspaceId },
      },
    })

  return { create, loading }
}
